"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var countriesWithTranslation = {
  // add countries with translation support here. eg:
  // see deprecated_japan.js
};

var translateCardShortName = exports.translateCardShortName = function translateCardShortName(countryCode, shop, cardShortName) {
  var _ref = countriesWithTranslation[countryCode] || {},
      _ref$cards = _ref.cards,
      cards = _ref$cards === undefined ? {} : _ref$cards;

  return cards[shop] && cards[shop][cardShortName] ? cards[shop][cardShortName] : cardShortName;
};